import { Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { DefaultBodyComponent } from './default-layout/default-body/default-body.component';
import { authsGuard } from './services/auths.guard';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path:'login',
        component:LoginPageComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent
      },
      {
        path:'',
        component:DefaultBodyComponent,
        data: {
          title: 'Dashboard'
        },
        children: [
          {
            path:'',
            loadChildren:()=>import('./pages/pages.module').then((m)=>m.PagesModule)
          }
        ],
      // canActivate:[authsGuard]
      },
     
];
